import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Plano} from "../../models/plano";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {ValidatorService} from "../../core/services/validator.service";
import {EstadoService} from "../../services/estado.service";
import {MunicipioService} from "../../services/municipio.service";
import {NgxSpinnerService} from "ngx-spinner";
import {PlanoService} from "../../services/plano.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageService} from "../../core/services/message.service";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {LoginService} from "../../services/login.service";
import {NumericPipe} from "../../core/pipes/numeric.pipe";
import {TinymceService} from "../../core/services/tinymce.service";
import {Usuario} from "../../models/usuario";
import {UsuarioService} from "../../services/usuario.service";
import {AcompanhamentoService} from "../../services/acompanhamento.service";

@Component({
    selector: 'app-plano',
    templateUrl: './plano.component.html',
    styleUrls: ['./plano.component.scss']
})
export class PlanoComponent implements OnInit {

    public plano: Plano;
    public form: FormGroup;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;
    public disabled: boolean = false;
    public usuario: Usuario;

    constructor(private loadingService: NgxSpinnerService,
                private messageService: MessageService,
                private router: Router,
                private route: ActivatedRoute,
                private planoService: PlanoService,
                private estadoService: EstadoService,
                private municipioService: MunicipioService,
                private loginService: LoginService,
                private usuarioService: UsuarioService,
                private acompanhamentoService: AcompanhamentoService,
    ) {

    }

    ngOnInit() {
        let login: Login = this.loginService.getAuth();

        let url: string;
        if (login) {
            if (login.perfil != Perfil.GESTOR) {
                url = "/gerencial";
                this.router.navigateByUrl(url);
            }
        } else {
            url = "/login";
            this.router.navigateByUrl(url);
        }
        this.form = new FormGroup({
            uf: new FormControl(null, [
                Validators.required
            ]),
            cod_municipio: new FormControl(null, [
                Validators.required
            ]),
            num_populacao_estimada: new FormControl({value: null, disabled: true}, [
                Validators.required,
                ValidatorService.number
            ]),
            num_cnpj: new FormControl(null, [
                Validators.required,
                ValidatorService.cnpj
            ]),
            num_cep: new FormControl(null, [
                Validators.required,
                ValidatorService.cep
            ]),
            num_telefone: new FormControl(null, [
                Validators.required,
                ValidatorService.telefone
            ]),
        });
        let id: number = this.route.snapshot.params.id;
        if (id) {
            this.carregarPlano(id);
        } else {
            this.plano = new Plano();
        }
        this.carregarUsuario(login.num_cpf.toString());
        this.carregarEstados();
    }

    carregarPlano(id: number): void {
        let pipe: NumericPipe = new NumericPipe();
        this.loadingService.show();
        this.disabled = true;
        this.planoService.findById(id).subscribe((plano: Plano) => {
            this.plano = plano;
            this.form.patchValue({
                uf: this.plano.municipio.txt_sigla_uf,
                cod_municipio: this.plano.municipio.cod_ibge_estimativa_populacao,
                num_populacao_estimada: pipe.transform(this.plano.municipio.num_populacao_estimada),
                num_cep: this.plano.num_cep,
                num_cnpj: this.plano.num_cnpj,
                num_telefone: this.plano.num_telefone,
            });
            if (this.plano.municipio.txt_sigla_uf) {
                this.carregarMunicipios(this.plano.municipio.txt_sigla_uf);
            }
            this.loadingService.hide();
        });
    }

    carregarEstados(): void {
        this.loadingService.show();
        this.estados = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
        this.form.patchValue({
            cod_municipio: null,
            num_populacao_estimada: null
        });
    }

    carregarUsuario(cpf: string): any {
        this.loadingService.show();
        let num_populacao_estimada: number;

        this.usuarioService.findByCpf(cpf).subscribe(async (usuario: Usuario) => {
            let pipe: NumericPipe = new NumericPipe();
            this.usuario = usuario;
            this.municipios = await this.municipioService.listAll(this.usuario.txt_sigla_uf).toPromise();

            this.municipios.forEach((municipio: Municipio) => {
                if (municipio.cod_ibge_estimativa_populacao == this.usuario.cod_municipio) {
                    num_populacao_estimada = municipio.num_populacao_estimada;
                }
            });

            this.form.patchValue({
                uf: this.usuario.txt_sigla_uf,
                cod_municipio: this.usuario.cod_municipio,
                num_populacao_estimada: pipe.transform(num_populacao_estimada),
                num_cnpj: this.usuario.num_cnpj,
                num_telefone: this.usuario.num_telefone,
            });
            this.disabled = true;
            this.loadingService.hide();
        }, (error) => {
            this.loadingService.hide();
            this.messageService.showResponseError(error);
        });
    }

    carregarMunicipios(uf: string): void {
        this.municipios = [];
        if (uf) {
            this.loadingService.show();
            this.municipioService.listAll(uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
                this.loadingService.hide();
            }, () => {
                this.loadingService.hide();
            });
            if (!this.form.get('cod_municipio').value) {
                this.form.patchValue({
                    num_populacao_estimada: null
                });
            }
        }
    }

    mostrarPopulacaoEstimadaIbge(cod_municipio: number) {
        let num_populacao_estimada: number;
        if (this.municipios.length == 0 || !cod_municipio) {
            num_populacao_estimada = null;
        } else {
            this.municipios.forEach((municipio: Municipio) => {
                if (municipio.cod_ibge_estimativa_populacao == cod_municipio) {
                    num_populacao_estimada = municipio.num_populacao_estimada;
                }
            });
        }
        let pipe: NumericPipe = new NumericPipe();
        this.form.patchValue({
            num_populacao_estimada: pipe.transform(num_populacao_estimada)
        });
    }

    save(): void {
        this.form.markAsTouched();
        if (this.form.valid) {
            this.loadingService.show();
            let form: Plano = this.form.value as Plano;
            form.cod_plano = this.plano.cod_plano;
            this.planoService.save(form).subscribe((data: any) => {
                this.acompanhamentoService.acompanhamento('registrar', data.plano_id).subscribe((response: any) => {
                    this.loadingService.hide();
                    if (response.responseCode == 500) {
                        console.warn(response.responseMessage);
                        this.messageService.showError("Não foi possivel registrar o inicio do acompanhamento");
                    } else if (response.responseCode == 200) {
                        this.messageService.showSuccess("Plano salvo com sucesso");
                        this.messageService.showSuccess(response.responseMessage.message);
                    }
                    this.router.navigateByUrl("/planos");
                }, (error) => {
                    this.loadingService.hide();
                    console.log(error)
                    this.messageService.showResponseError(error);
                });

            }, (error) => {
                this.loadingService.hide();
                console.log(error)
                this.messageService.showResponseError(error);
            });
        }
    }
}
